import { handleResponse } from '../Helpers/handle-response';
import { authHeader, authFileHeader } from '../Helpers/auth-header';
import { getCrudFetchString} from '../Helpers/crudHelper'

export const crudService = {
    tableOverview,
    deleteTableRow,
    addTableRow,
    editTableRow,
    importExcel
};

function tableOverview(schemeName, tableName, userToken) {
    const requestOptions = { method: 'GET', headers: authHeader(userToken) };
    return fetch(getCrudFetchString(schemeName, tableName), requestOptions).then(handleResponse);
}

function deleteTableRow(schemeName, tableName, userToken, id) {
    const requestOptions = { method: 'DELETE', headers: authHeader(userToken) };
    return fetch(getCrudFetchString(schemeName, tableName) + "/" + id, requestOptions).then(handleResponse);
}

function addTableRow(schemeName, tableName, userToken, row) {
  const requestOptions = { method: 'POST', headers: authHeader(userToken),body: JSON.stringify(row) };
  return fetch(getCrudFetchString(schemeName, tableName), requestOptions).then(handleResponse);
}

function editTableRow(schemeName, tableName, userToken, row) {
  const requestOptions = { method: 'PUT', headers: authHeader(userToken),body: JSON.stringify(row) };
  return fetch(getCrudFetchString(schemeName, tableName), requestOptions).then(handleResponse);
}

function importExcel(schemeName, tableName, userToken, file) {
  const requestOptions = { method: 'POST', headers: authFileHeader(userToken),body: file };
  return fetch(getCrudFetchString(schemeName, tableName) + "/import", requestOptions).then(handleResponse);
}